// @ts-nocheck
export function initWhatsAppToast() {
  const toast = document.getElementById("radiospro-wa-toast");
  if (!toast || toast.dataset.rpBound === "1") return;
  toast.dataset.rpBound = "1";

  const JOINED_KEY = "radiospro_wa_group_joined_v1";
  const DISMISS_KEY = "radiospro_wa_group_dismiss_until_v1";
  const INITIAL_DELAY_MS = 6000;
  const SLIDE_MS = 450;
  const DISMISS_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;
  let leaveTimer = null;

  function hasJoined() {
    try {
      return window.localStorage.getItem(JOINED_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function markJoined() {
    try {
      window.localStorage.setItem(JOINED_KEY, "1");
      window.localStorage.removeItem(DISMISS_KEY);
    } catch (e) {}
  }

  function isDismissCoolingDown() {
    try {
      const until = parseInt(window.localStorage.getItem(DISMISS_KEY) || "0", 10);
      return until > Date.now();
    } catch (e) {
      return false;
    }
  }

  function markDismissSoft() {
    try {
      window.localStorage.setItem(DISMISS_KEY, String(Date.now() + DISMISS_COOLDOWN_MS));
    } catch (e) {}
  }

  function canShow() {
    return !hasJoined() && !isDismissCoolingDown();
  }

  function showToast() {
    if (!canShow()) return;
    if (leaveTimer) {
      clearTimeout(leaveTimer);
      leaveTimer = null;
    }
    toast.classList.remove("is-leaving");
    toast.classList.add("is-visible");
    toast.setAttribute("aria-hidden", "false");
  }

  function hideToast(options) {
    options = options || {};
    toast.classList.add("is-leaving");
    toast.classList.remove("is-visible");
    toast.setAttribute("aria-hidden", "true");
    if (leaveTimer) clearTimeout(leaveTimer);
    leaveTimer = setTimeout(function () {
      toast.classList.remove("is-leaving");
      leaveTimer = null;
    }, SLIDE_MS);
    if (options.joined) markJoined();
    else if (options.dismiss) markDismissSoft();
  }

  const dismissBtn = document.getElementById("radiospro-wa-toast-dismiss");
  const ctaBtn = document.getElementById("radiospro-wa-toast-cta");

  if (dismissBtn) {
    dismissBtn.addEventListener("click", function () {
      hideToast({ dismiss: true });
    });
  }
  if (ctaBtn) {
    ctaBtn.addEventListener("click", function () {
      markJoined();
      hideToast({ joined: true });
    });
  }

  if (canShow()) {
    setTimeout(showToast, INITIAL_DELAY_MS);
  }
}
